import { Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { log } from 'utils';
import _ from 'underscore';
import { EmptyIcon } from 'assets/icon/bigicon';
import { FilterIcon } from 'assets/icon';
import ModalDelete from 'components/ModalDelete';
import Cards from 'design-components/Cards';
import CategoryDropdown from 'components/CategoryDropdown';
import {
  deleteWebContents,
  fetchWebContents,
} from 'state/actions/webContents';
import {
  createInformationCategory,
  deleteInformationCategory,
  modifyInformationCategory,
  setInformationCategory,
} from 'state/actions/informationCategories';
import ModalInformationCategoryForm from 'components/ModalInformationCategoryForm';
import AddPostingForm from './AddPostingForm';

const PostingPage = () => {
  const { siteId } = useParams();

  const {
    webContentData,
    informationCategories,
    loading,
    userData,
    role,
    category,
    categoryLoading,
  } = useSelector(
    (state) => ({
      webContentData: state.webContents.list,
      informationCategories: state.informationCategories.list,
      loading: state.webContents.loading,
      userData: state.auth.userData,
      role: state.auth.userData.role,
      category: state.informationCategories.category,
      categoryLoading: state.informationCategories.loading,
    }),
    shallowEqual
  );

  if (webContentData) {
    log(webContentData, '<<< web content data');
  }

  const [deleteModal, setDeleteModal] = useState({
    information: null,
    isOpen: false,
  });

  const dispatch = useDispatch();

  const [search, setSearch] = useState();
  const [activeCategory, setActiveCategory] = useState('all');
  const [tempSelectedCategory, setTempSelectedCategory] = useState('all');
  const [playlistOpen, setPlaylistOpen] = useState(false);
  const [modalCategory, setModalCategory] = useState(false);
  const [dragDropElement, setDragDropElement] = useState({
    dragged: '',
    enter: '',
  });
  const [modalDeleteCategory, setModalDeleteCategory] = useState({
    show: false,
    category: null,
  });

  const [showAddPosting, setShowAddPosting] = useState(false);
  const [selectedPostData, showSelectedPostData] = useState([]);

  const uid = userData.id;

  useEffect(() => {
    dispatch(fetchWebContents({ siteId }));
  }, [siteId]); // eslint-disable-line

  const onRemoveButtonClickHandler = (information) => {
    setDeleteModal({
      information,
      isOpen: true,
    });
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ information: null, isOpen: false });
  };

  const onDeleteInformationHandler = () => {
    dispatch(
      deleteWebContents({ id: deleteModal.information, siteId }, () => {
        onCloseModalHandler();
      })
    );
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const dataByCategory = webContentData.filter((content) => {
    return activeCategory !== 'all'
      ? content.categoryId === activeCategory
      : true;
  });

  const filteredData = search
    ? webContentData.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name?.toLowerCase().includes(search.toLowerCase());
      })
    : dataByCategory;

  const getCategory = (categoryId) => {
    const findCategory = informationCategories.find(
      (cat) => cat._id === categoryId
    );
    return findCategory?.name;
  };

  const handleSetPlaylist = () => {
    setActiveCategory(tempSelectedCategory);
    setPlaylistOpen(false);
  };

  const handleEdit = (data) => {
    setShowAddPosting(true);
    showSelectedPostData(data);
  };

  const onSubmitCategory = () => {
    const action = category._id
      ? modifyInformationCategory
      : createInformationCategory;

    dispatch(
      action({ uid, ...category, siteId, id: category._id }, () =>
        setModalCategory(false)
      )
    );
  };

  const handleSetCategory = (data) => {
    dispatch(setInformationCategory(data));
  };

  const handleEditCategory = (category) => {
    dispatch(setInformationCategory(category));
    setModalCategory(true);
  };

  const handleDeleteCategory = (category) => {
    setModalDeleteCategory({
      show: true,
      category,
    });
  };

  const onDeleteCategory = () => {
    dispatch(
      deleteInformationCategory(modalDeleteCategory.category._id, () =>
        onCloseModalCategoryHandler()
      )
    );
  };

  const onCloseModalCategoryHandler = () => {
    setModalDeleteCategory({
      show: false,
      category: null,
    });
  };

  const handleNew = () => {
    dispatch(
      setInformationCategory(
        {
          _id: '',
          name: '',
          description: '',
        },
        () => setModalCategory(true)
      )
    );
  };

  return showAddPosting ? (
    <AddPostingForm
      predefinedData={selectedPostData}
      closeAddPosting={() => {
        showSelectedPostData([]);
        setShowAddPosting(false);
      }}
    />
  ) : (
    <div style={{ width: '100%', marginLeft: '16px' }}>
      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={onDeleteInformationHandler}
        onCancel={onCloseModalHandler}
        title="Delete Post"
        subtitle={deleteModal.information ? deleteModal.information.name : ''}
        loading={loading}
      />

      <div className="config-page-header">
        <div className="config-page-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                onChange={handleSearch}
              />
            </div>
          </div>
          <div
            className="playlist-wrapper"
            onClick={() => setPlaylistOpen(!playlistOpen)}
          >
            <div className="playlist-selection">
              <FilterIcon />
              <span>
                {activeCategory === 'all'
                  ? 'Show All'
                  : getCategory(activeCategory)}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                playlistOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={informationCategories}
              setTempSelectedCategory={(id) => setTempSelectedCategory(id)}
              handleEditCategory={
                role === 'superadmin' ? (cat) => handleEditCategory(cat) : null
              }
              handleDeleteCategory={
                role === 'superadmin'
                  ? (cat) => handleDeleteCategory(cat)
                  : null
              }
              modalOpen={playlistOpen}
              handleSetPlaylist={handleSetPlaylist}
              tempSelectedCategory={tempSelectedCategory}
              handleNew={role === 'superadmin' ? handleNew : null}
              filter
            />
          </div>
        </div>
        <div className="actions__wrapper">
          <div
            className="btn-primary"
            onClick={() => {
              setShowAddPosting(true);
              showSelectedPostData([]);
            }}
          >
            <i className="feather-plus mr-2" />
            Add Post
          </div>
        </div>
      </div>

      <div className="config-page-content-wrapper">
        <div className="config-page-content">
          {loading ? (
            <span>Loading...</span>
          ) : (
            <div className="config-page-list-content">
              {webContentData?.length > 0 && filteredData.length > 0 ? (
                _.chunk(filteredData, 3).map((chunk, index) => {
                  return (
                    <div className="config-page-list-chunk" key={index}>
                      {chunk.map((content) => {
                        return (
                          <div
                            key={content._id}
                            data-id={content._id}
                            className={`config-page-list ${
                              dragDropElement.dragged === content._id
                                ? 'dragged'
                                : ''
                            } ${
                              dragDropElement.enter === content._id
                                ? 'entered'
                                : ''
                            }`}
                            draggable
                            onDragStart={() =>
                              setDragDropElement({
                                ...dragDropElement,
                                dragged: content._id,
                              })
                            }
                            onDragEnd={() =>
                              setDragDropElement({
                                ...dragDropElement,
                                dragged: '',
                              })
                            }
                            onDragEnter={() => {
                              setDragDropElement({
                                ...dragDropElement,
                                enter: content._id,
                              });
                            }}
                            onDragOver={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onDrop={() => {}}
                          >
                            <Cards
                              data={content}
                              type="content"
                              isDelete={true}
                              editAction={() => handleEdit(content)}
                              deleteAction={() =>
                                onRemoveButtonClickHandler(content._id)
                              }
                            />
                          </div>
                        );
                      })}
                      {chunk.length < 2 && (
                        <div className="config-page-list-empty" />
                      )}
                      {chunk.length < 3 && (
                        <div className="config-page-list-empty" />
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="config-page-empty">
                  <Empty image={<img src={EmptyIcon} alt="empty" />} description="No Information" />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostingPage;
